import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ConfirmDialog } from '@openng/optimus-ui/confirmdialog';

/**
 * The single confirmation dialog the app renders. Asking is done through
 * `UiConfirmService`; this component only draws the pending question.
 */
@Component({
  selector: 'ui-confirm-dialog',
  imports: [ConfirmDialog],
  standalone: true,
  template: '<p-confirmDialog />',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiConfirmDialogComponent {}
